<script setup lang="ts">
import type { Emit } from '../lib/types';

import { ButtonQC } from '@qicgroupdoha/qic-connect-ds';
import { PHONE } from '../lib/consts';

const emit = defineEmits<Emit>();

function clickHanlder() {
  emit('click');
  window.location.href = `tel:${PHONE.replaceAll(' ', '')}`;
}
</script>

<template>
  <ButtonQC size="medium" variant="outline" @click="clickHanlder">
    {{ $t('renew.common.call') }} <span class="btn__phone">{{ PHONE }}</span>
  </ButtonQC>
</template>

<style scoped lang="scss">
@use 'HotlineButton';
</style>
